const Style = () => ({
  flex__bw: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    padding: '2rem 0',
  },
  main__btn: {
    width: '125px',
    height: '42px',
    fontSize: '13px',
    fontWeight: '500',
    borderRadius: '100px',
    boxShadow: 'none',
  },
  estimate__btn: {
    background: 'var(--color-secondary)',
    color: '#fff',
    '&:hover': {
      background: 'var(--color-secondary)',
      boxShadow: 'none',
    },
  },
  ro__btn: {
    background: 'var(--color-primary)',
    color: '#fff',
    marginLeft: '.7rem',
    '&:hover': {
      background: 'var(--color-primary)',
      boxShadow: 'none',
    },
  },
  cancel__btn: {
    color: 'rgb(45, 68, 87)',
    background: 'rgba(109, 125, 139, 0.2)',
    '&:hover': {
      background: 'rgba(109, 125, 139, 0.2)',
      boxShadow: 'none',
    },
  },
  disabled__action__btn: {
    background: 'rgba(109, 125, 139, 0.3)',
    color: 'rgba(109, 125, 139, 0.5)',
    '& svg': {
      '& path': {
        stroke: 'rgba(109, 125, 139, 0.5)',
      },
    },
    '&:hover': {
      background: 'rgba(109, 125, 139, 0.3)',
    },
  },
});
export default Style;
